import { Ban, RotateCcw, Loader2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';

export const EVENT_TYPE_LABELS = {
  'talent_created': 'Talent Created',
  'talent_deleted': 'Talent Deleted',
  'status_changed': 'Status Changed',
  'status_set': 'Status Set',
  'stage_changed': 'Stage Changed',
  'stage_set': 'Stage Set',
  'talent_type_set': 'Type Set',
  'talent_type_changed': 'Type Changed',
  'profile_updated': 'Profile Updated',
  'manager_changed': 'Manager Changed',
  'professions_added': 'Professions Added',
  'professions_updated': 'Professions Updated',
  'media_added': 'Media Added',
  'media_updated': 'Media Updated',
  'media_uploaded': 'Media Uploaded',
  'media_removed': 'Media Removed',
  'media_record_created': 'Media Record Created',
  'media_file_updated': 'Media File Updated',
  'media_file_deleted': 'Media File Deleted',
  'cv_added': 'CV Added',
  'cv_created': 'CV Created',
  'cv_updated': 'CV Updated',
  'contacts_added': 'Contacts Added',
  'contacts_updated': 'Contacts Updated',
  'languages_added': 'Languages Added',
  'languages_updated': 'Languages Updated',
  'responsibilities_added': 'Responsibilities Added',
  'responsibilities_updated': 'Responsibilities Updated',
  'tools_added': 'Tools Added',
  'tools_updated': 'Tools Updated',
  'communications_updated': 'Communications Updated',
  'communication_created': 'Communication Created',
  'communication_updated': 'Communication Updated',
  'communication_deleted': 'Communication Deleted',
  'notes_updated': 'Notes Updated',
  'note_created': 'Note Created',
  'note_updated': 'Note Updated',
  'note_deleted': 'Note Deleted',
  'important_dates_updated': 'Important Dates Updated',
  'important_date_created': 'Important Date Created',
  'important_date_updated': 'Important Date Updated',
  'important_date_deleted': 'Important Date Deleted',
  'ai_setting_created': 'AI Setting Created',
  'ai_setting_updated': 'AI Setting Updated',
  'ai_setting_deleted': 'AI Setting Deleted',
  'salary_created': 'Salary Created',
  'salary_updated': 'Salary Updated',
  'public_settings_created': 'Public Settings Created',
  'public_settings_updated': 'Public Settings Updated',
  'visibility_changed': 'Visibility Changed',
  'data_anonymized': 'Data Anonymized',
  'job_application_auto_created': 'Job Application Created',
  'job_application_created': 'Job Application Created',
  'job_application_status_changed': 'Application Status Changed',
  'job_application_updated': 'Job Application Updated',
  'job_application_deleted': 'Job Application Deleted',
  'talent_post_created': 'Post Created',
  'talent_post_updated': 'Post Updated',
  'talent_post_published': 'Post Published',
  'talent_post_unpublished': 'Post Unpublished',
  'talent_post_deleted': 'Post Deleted',
  'talent_post_generated': 'Post Generated',
  'talent_post_terms_updated': 'Post Terms Updated',
  'talent_post_terms_cleared': 'Post Terms Cleared',
  'talent_post_prices_updated': 'Post Prices Updated',
  'talent_post_prices_deleted': 'Post Prices Deleted',
  'talent_template_created': 'Template Created',
  'talent_template_updated': 'Template Updated',
  'talent_template_deleted': 'Template Deleted',
  'prompt_template_created': 'Prompt Created',
  'prompt_template_updated': 'Prompt Updated',
  'prompt_template_deleted': 'Prompt Deleted',
  'course_completed': 'Course Completed',
  'skills_added': 'Skills Added',
};

export const EVENT_TYPE_ICONS = {
  'talent_created': '🎯',
  'talent_deleted': '🗑️',
  'status_changed': '🔄',
  'status_set': '🔄',
  'stage_changed': '🪜',
  'stage_set': '🪜',
  'talent_type_set': '🏷️',
  'talent_type_changed': '🏷️',
  'profile_updated': '✏️',
  'manager_changed': '👤',
  'professions_added': '💼',
  'professions_updated': '💼',
  'media_added': '📱',
  'media_updated': '📱',
  'media_uploaded': '📤',
  'media_removed': '🗑️',
  'media_record_created': '📱',
  'media_file_updated': '📱',
  'media_file_deleted': '🗑️',
  'cv_added': '📄',
  'cv_created': '📄',
  'cv_updated': '📄',
  'contacts_added': '📞',
  'contacts_updated': '📞',
  'languages_added': '🌐',
  'languages_updated': '🌐',
  'responsibilities_added': '📋',
  'responsibilities_updated': '📋',
  'tools_added': '🔧',
  'tools_updated': '🔧',
  'communications_updated': '💬',
  'communication_created': '💬',
  'communication_updated': '✏️',
  'communication_deleted': '🗑️',
  'notes_updated': '📝',
  'note_created': '📝',
  'note_updated': '✏️',
  'note_deleted': '🗑️',
  'important_dates_updated': '📅',
  'important_date_created': '📅',
  'important_date_updated': '📅',
  'important_date_deleted': '🗑️',
  'ai_setting_created': '🤖',
  'ai_setting_updated': '🤖',
  'ai_setting_deleted': '🗑️',
  'salary_created': '💰',
  'salary_updated': '💰',
  'public_settings_created': '🌐',
  'public_settings_updated': '🌐',
  'visibility_changed': '👁️',
  'data_anonymized': '🔒',
  'job_application_auto_created': '📋',
  'job_application_created': '📝',
  'job_application_status_changed': '🔄',
  'job_application_updated': '✏️',
  'job_application_deleted': '🗑️',
  'talent_post_created': '📝',
  'talent_post_updated': '✏️',
  'talent_post_published': '🚀',
  'talent_post_unpublished': '🔕',
  'talent_post_deleted': '🗑️',
  'talent_post_generated': '🤖',
  'talent_post_terms_updated': '🏷️',
  'talent_post_prices_updated': '💲',
  'talent_template_created': '📋',
  'talent_template_updated': '✏️',
  'talent_template_deleted': '🗑️',
  'prompt_template_created': '🧠',
  'prompt_template_updated': '✏️',
  'prompt_template_deleted': '🗑️',
  'course_completed': '🎓',
  'skills_added': '⚡',
};

export const getEventColor = (t) => {
  if (t.includes('deleted') || t.includes('removed') || t.includes('anonymized')) {
    return 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400';
  }
  if (t.includes('created') || t.includes('added') || t.includes('auto_created')) {
    return 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400';
  }
  if (t.includes('published') && !t.includes('un')) {
    return 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400';
  }
  if (t.includes('unpublished')) {
    return 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400';
  }
  if (t.includes('status') || t.includes('stage') || t.includes('changed')) {
    return 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400';
  }
  if (t.includes('generated') || t.includes('ai_')) {
    return 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400';
  }
  return 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400';
};

export const formatEventType = (t) =>
  EVENT_TYPE_LABELS[t] || t.replace(/_/g, ' ');

/** Контейнеры со снимками значений внутри event_data — совпадают с бэкендом */
const VALUE_CONTAINERS = ['old_values', 'new_values', 'old_settings', 'new_settings'];

/** Человекочитаемые заголовки полей в таблице изменений */
const FIELD_LABELS = {
  current_status_id: 'Status',
  current_stage_id: 'Stage',
  manager_id: 'Manager',
  auth_user_id: 'Auth User',
  job_application_id: 'Job Application',
  created_by: 'Created By',
  updated_by: 'Updated By',
  changed_by: 'Changed By',
  status_updated_by: 'Status Updated By',
  stage_updated_by: 'Stage Updated By',
  from_status_id: 'Status From',
  to_status_id: 'Status To',
  from_stage_id: 'Stage From',
  to_stage_id: 'Stage To',
  city_id: 'City',
  country_id: 'Country',
  level_id: 'Level',
  rate_id: 'Rate',
  shift_id: 'Shift',
  expectations_currency_id: 'Expectations Currency',
  proposed_salary_currency_id: 'Proposed Salary Currency',
};

export const formatFieldName = (field) =>
  FIELD_LABELS[field] ||
  field
    .replace(/_id$/, '')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());

/**
 * Собрать пары «старое → новое» для таблицы изменений.
 * Часть событий пишет changed_fields/old_values/new_values (профиль),
 * часть — old_settings/new_settings (зарплата, публичные настройки).
 */
const getEventDiff = (event) => {
  const data = event.event_data;
  if (!data) return null;

  const labels = event.event_data_labels || {};

  if (data.changed_fields?.length > 0 && data.old_values) {
    return {
      fields: data.changed_fields,
      oldValues: data.old_values || {},
      newValues: data.new_values || {},
      oldLabels: labels.old_values || {},
      newLabels: labels.new_values || {},
    };
  }

  if (data.old_settings || data.new_settings) {
    const oldValues = data.old_settings || {};
    const newValues = data.new_settings || {};
    const fields = [...new Set([...Object.keys(oldValues), ...Object.keys(newValues)])]
      .filter((field) => JSON.stringify(oldValues[field] ?? null) !== JSON.stringify(newValues[field] ?? null));

    if (fields.length === 0) return null;

    return {
      fields,
      oldValues,
      newValues,
      oldLabels: labels.old_settings || {},
      newLabels: labels.new_settings || {},
    };
  }

  return null;
};

export const formatRelative = (dateStr) => {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString();
};

const formatDate = (dateStr) =>
  new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric', month: 'short', day: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });

/**
 * Unified event card component.
 *
 * Props:
 *   event        — event object (with is_cancelled, cancel_reason, cancelled_by, event_data, etc.)
 *   usersMap     — { [userId]: { name, avatar } } — optional, used for avatar + cancelled_by name
 *   entity       — { url, type, name } — optional, shown as a link (ActivityFeed mode)
 *   canCancel    — boolean, show cancel/restore button
 *   onCancel     — (eventId) => void
 *   onUncancel   — (eventId) => void
 *   actionLoading — eventId currently loading, or null
 */
const EventCard = ({ event, usersMap = {}, entity = null, canCancel = false, onCancel, onUncancel, actionLoading = null }) => {
  // Prefer aggregated user object from gateway, fall back to usersMap lookup, then raw id
  const resolvedUser = event.user || usersMap[event.user_id] || null;
  const userName = resolvedUser?.name ?? (event.user_id ? event.user_id : 'System');
  const avatarUrl = resolvedUser?.avatar ?? null;
  const isCancelled = event.is_cancelled;
  const isLoading = actionLoading === event.id;
  const resolvedCancelledByUser = event.cancelledByUser || usersMap[event.cancelled_by] || null;
  const cancelledByName = resolvedCancelledByUser?.name || event.cancelled_by || null;
  const diff = getEventDiff(event);
  // Названия, разрезолвленные для полей в корне event_data (status_changed, manager_changed и т.п.)
  const rootLabels = Object.entries(event.event_data_labels || {}).filter(
    ([field, label]) => !VALUE_CONTAINERS.includes(field) && label !== null && label !== undefined
  );

  return (
    <div className={`bg-light-bg-primary dark:bg-dark-bg-primary border rounded-lg p-4 transition-colors ${
      isCancelled
        ? 'border-red-200 dark:border-red-800/50 opacity-60'
        : 'border-light-border-primary dark:border-dark-border-primary hover:border-primary-300 dark:hover:border-primary-600'
    }`}>
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5">
          <Avatar avatar={avatarUrl} name={userName} size="sm" />
        </div>

        <div className="flex-1 min-w-0">
          {/* User + time */}
          <div className="flex items-center gap-2 flex-wrap mb-1">
            <span className="font-medium text-sm text-light-text-primary dark:text-dark-text-primary">
              {userName}
            </span>
            <span
              className="text-xs text-light-text-tertiary dark:text-dark-text-tertiary"
              title={new Date(event.occurred_at).toLocaleString()}
            >
              {formatRelative(event.occurred_at)}
            </span>
            <span className="text-xs text-light-text-tertiary dark:text-dark-text-tertiary">
              · {formatDate(event.occurred_at)}
            </span>
          </div>

          {/* Event type badge + entity link (if provided) */}
          <div className="flex items-center gap-2 flex-wrap mb-2">
            <span className="text-base">{EVENT_TYPE_ICONS[event.event_type] || '📝'}</span>
            <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${isCancelled ? 'line-through opacity-70' : ''} ${getEventColor(event.event_type)}`}>
              {formatEventType(event.event_type)}
            </span>

            {isCancelled && (
              <span
                className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400"
                title={event.cancel_reason ? `Reason: ${event.cancel_reason}` : undefined}
              >
                <Ban className="h-3 w-3 flex-shrink-0" />
                Cancelled{event.cancel_reason && `: "${event.cancel_reason}"`}
              </span>
            )}

            {entity && (
              <>
                <span className="text-xs text-light-text-secondary dark:text-dark-text-secondary">on</span>
                <Link
                  to={entity.url}
                  className="text-xs font-medium text-primary-600 dark:text-primary-400 hover:underline truncate max-w-xs"
                  title={entity.name}
                >
                  {entity.type}: {entity.name}
                </Link>
              </>
            )}
          </div>

          {/* Business context */}
          {event.business_context && (
            <p className="text-xs text-light-text-secondary dark:text-dark-text-secondary mb-2 italic">
              {event.business_context}
            </p>
          )}

          {/* Cancelled by */}
          {isCancelled && cancelledByName && (
            <p className="text-xs text-red-500 dark:text-red-400 mb-2">
              Cancelled by {cancelledByName}
              {event.cancel_reason && `: "${event.cancel_reason}"`}
            </p>
          )}

          {/* Diff table or details */}
          {diff ? (
            <div className="mt-2">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="text-light-text-tertiary dark:text-dark-text-tertiary">
                    <th className="text-left py-1 pr-3 font-medium w-1/4">Field</th>
                    <th className="text-left py-1 pr-3 font-medium w-[37.5%]">Old</th>
                    <th className="text-left py-1 font-medium w-[37.5%]">New</th>
                  </tr>
                </thead>
                <tbody>
                  {diff.fields.map((field) => {
                    // Если api-gateway разрезолвил id в название — показываем название,
                    // а сам id оставляем во всплывающей подсказке
                    const fmt = (v, label) => {
                      if (label !== undefined && label !== null) {
                        return (
                          <span className="break-all" title={`${field}: ${JSON.stringify(v)}`}>
                            {Array.isArray(label) ? label.join(', ') : String(label)}
                          </span>
                        );
                      }
                      if (v === null || v === undefined) return <span className="opacity-40">—</span>;
                      if (typeof v === 'object') return <span className="font-mono opacity-70 break-all">{JSON.stringify(v)}</span>;
                      return <span className="break-all">{String(v)}</span>;
                    };
                    return (
                      <tr key={field} className="border-t border-light-border-primary dark:border-dark-border-primary">
                        <td
                          className="py-1 pr-3 text-light-text-tertiary dark:text-dark-text-tertiary align-top"
                          title={field}
                        >
                          {formatFieldName(field)}
                        </td>
                        <td className="py-1 pr-3 text-red-500 dark:text-red-400 line-through opacity-70 align-top">
                          {fmt(diff.oldValues[field], diff.oldLabels[field])}
                        </td>
                        <td className="py-1 text-green-600 dark:text-green-400 align-top">
                          {fmt(diff.newValues[field], diff.newLabels[field])}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : event.event_data && (
            <div className="mt-2 text-xs text-light-text-tertiary dark:text-dark-text-tertiary">
              {rootLabels.length > 0 && (
                <div className="flex flex-wrap gap-x-4 gap-y-1 mb-2">
                  {rootLabels.map(([field, label]) => (
                    <span key={field} title={`${field}: ${JSON.stringify(event.event_data[field])}`}>
                      {formatFieldName(field)}:{' '}
                      <span className="text-light-text-primary dark:text-dark-text-primary">
                        {Array.isArray(label) ? label.join(', ') : String(label)}
                      </span>
                    </span>
                  ))}
                </div>
              )}
              <details className="cursor-pointer">
                <summary className="hover:text-light-text-secondary dark:hover:text-dark-text-secondary transition-colors">
                  Details
                </summary>
                <pre className="mt-2 p-3 bg-light-bg-tertiary dark:bg-dark-bg-tertiary border border-light-border-primary dark:border-dark-border-primary rounded text-xs overflow-x-auto text-light-text-primary dark:text-dark-text-primary">
                  {JSON.stringify(event.event_data, null, 2)}
                </pre>
              </details>
            </div>
          )}
        </div>

        {/* Cancel / Restore button */}
        {canCancel && (
          <div className="flex-shrink-0 ml-2">
            {isCancelled ? (
              <button
                onClick={() => onUncancel(event.id)}
                disabled={isLoading}
                title="Restore event to statistics"
                className="flex items-center gap-1 px-2 py-1 rounded text-xs text-green-600 dark:text-green-400 border border-green-200 dark:border-green-800 hover:bg-green-50 dark:hover:bg-green-900/20 disabled:opacity-50 transition-colors"
              >
                {isLoading ? <Loader2 className="h-3 w-3 animate-spin" /> : <RotateCcw className="h-3 w-3" />}
                Restore
              </button>
            ) : (
              <button
                onClick={() => onCancel(event.id)}
                disabled={isLoading}
                title="Exclude event from statistics"
                className="flex items-center gap-1 px-2 py-1 rounded text-xs text-red-500 dark:text-red-400 border border-red-200 dark:border-red-800 hover:bg-red-50 dark:hover:bg-red-900/20 disabled:opacity-50 transition-colors"
              >
                {isLoading ? <Loader2 className="h-3 w-3 animate-spin" /> : <Ban className="h-3 w-3" />}
                Exclude from stats
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCard;
